module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "belief",
    style: ({
      height: _vm.height
    })
  }, [_c('b-header'), _c('div', {
    directives: [{
      name: "fullpage",
      rawName: "v-fullpage",
      value: (_vm.opts),
      expression: "opts"
    }],
    ref: "fullpage",
    staticClass: "container"
  }, [_c('div', {
    staticClass: "page",
    style: ({
      height: _vm.height,
      overflowY: 'scroll',
      paddingBottom: '20px'
    })
  }, [_c('div', {
    staticClass: "nav"
  }, [_c('transition', {
    attrs: {
      "name": "left-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "line"
  })]), _c('transition', {
    attrs: {
      "name": "right-in"
    }
  }, [_c('div', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.init),
      expression: "init"
    }],
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.langs[_vm.lang].belief))])])], 1), _c('div', {
    staticClass: "talk"
  }, [_c('p', [_vm._v(_vm._s(_vm.langs[_vm.lang].detail1)), _c('br'), _vm._v(_vm._s(_vm.langs[_vm.lang].detail2))])]), _c('div', {
    staticClass: "timeline"
  }, [_c('transition', {
    attrs: {
      "appear": "appear",
      "name": "left-in"
    }
  }, [_c('img', {
    staticClass: "line pc",
    attrs: {
      "src": require("../assets/timeline.png")
    }
  })]), _c('transition', {
    attrs: {
      "appear": "appear",
      "name": "top-in"
    }
  }, [_c('div', {
    staticClass: "line mobi"
  })]), _c('transition-group', {
    staticClass: "items",
    attrs: {
      "appear": "appear"
    },
    on: {
      "before-enter": _vm.beforeEnter,
      "enter": _vm.enter
    }
  }, _vm._l((_vm.list), function(value, index) {
    return _c('div', {
      key: "index",
      staticClass: "item",
      attrs: {
        "data-index": index
      }
    }, [(value.type === 'time') ? [_c('div', {
      staticClass: "time"
    }, [_c('div', {
      staticClass: "mask"
    }, [_vm._v(_vm._s(value.time))])]), _c('div', {
      staticClass: "descd"
    })] : [_c('div', {
      staticClass: "avatar",
      on: {
        "click": function($event) {
          return _vm.openLink(value.link)
        }
      }
    }, [_c('div', {
      staticClass: "mask"
    }), _c('img', {
      attrs: {
        "src": value.avatar
      }
    }), _c('div', {
      staticClass: "name"
    }, [_vm._v(_vm._s(value.name))]), _c('div', {
      staticClass: "title"
    }, [_vm._v(_vm._s(value.title))])]), _c('div', {
      staticClass: "desc"
    })]], 2)
  }), 0)], 1)])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-1be9e46c","hasScoped":true}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/belief.vue
// module id = 505
// module chunks = 1